import offers from "@/apollo/queries/offer/offers";
import offer from "@/apollo/queries/offer/offer";

export const state = () => ({
  offers: [],
  lastOffers: [],
  offer: null,
  loading: true,
  isOfferClick: false,
  carPageLoaded: false
});
export const getters = {
  offers: state => {
    return state.offers;
  },
  lastOffers: state => {
    return state.lastOffers;
  },
  offer: state => {
    return state.offer;
  },
  isOfferClick: state => {
    return state.isOfferClick;
  },
  view: state => {
    return state.view;
  },
  carPageLoaded: state => {
    return state.carPageLoaded;
  },
  loading: state => {
    return state.loading;
  }
};
export const actions = {
  async getOffer({ commit, rootState }, payload) {
    let variables = {
      site_id: rootState.site_id,
      mark_slug: payload.mark.slug,
      folder_slug: payload.folder.slug,
      external_id: payload.external_id ?? payload.id
    };
    let client = this.app.apolloProvider.defaultClient;
    let response = await client.query({
      query: offer,
      variables: variables
    });
    commit("SET_OFFER", response.data.offer);
  },
  async getOffers({ commit, rootState }, payload) {
    await commit("SET_LOADING", true);
    let variables = { site_id: rootState.site_id };
    let client = this.app.apolloProvider.defaultClient;
    let response = await client.query({
      query: offers,
      variables: Object.assign(variables, payload)
    });
    await commit("SET_OFFERS", response.data.offers.data);
    await commit("SET_LOADING", false);
  }
};
export const mutations = {
  SET_OFFERS(state, data) {
    const items = Array.isArray(data) ? data : data?.data;
    state.offers = Array.isArray(items)
      ? items.filter(Boolean).map(item => ({ ...item, external_id: item.external_id ?? item.id }))
      : [];
  },
  SET_LAST_OFFERS(state, data) {
    let local_data = [];
    if (localStorage.getItem("viewed_cars")) {
      local_data = JSON.parse(localStorage.getItem("viewed_cars"));
      if (local_data.length > 0) {
        let car = local_data.find(element => element.id === data.id);
        if (!car) {
          local_data.unshift(data);
        }
        if (local_data.length > 4) {
          local_data.pop();
        }
      } else {
        local_data.unshift(data);
      }
    } else {
      local_data.unshift(data);
    }

    localStorage.setItem("viewed_cars", JSON.stringify(local_data));
  },
  SET_OFFER(state, data) {
    state.offer = data ? { ...data, external_id: data.external_id ?? data.id } : null;
    state.isOfferClick = false;
  },
  SET_CAR_PAGE_LOADED(state, data) {
    state.carPageLoaded = data;
  },
  SET_LOADING(state, data) {
    state.loading = data;
  },
  SET_OFFER_CLICK(state, data) {
    state.isOfferClick = data;
  }
};
